import { SIG } from "../../common/apiUrl/sig/sigUrls";
import { ArchivedAPIresendAccessLinkJsonRequest, CommonSIGJsonRequest, ResendAccessLinkJsonRequest, SendForSignatureJsonRequest, SendForSignatureWithTextIdJsonRequest, SetAccessJsonRequest, SIGJsonRequestWithoutCallbackUri, SignatureStatusJsonRequest } from "../../common/model/sig/jsonRequest";
import { generateCallbackCurlCommand, generateCurlCommand, generateNoBodyCurlCommand } from "../helperFunctions";


const commonSIGJsonRequest: CommonSIGJsonRequest = {
    "documentId": "string",
    "correlationId": "string",
    "callbackUri": "string"
}

const sigJsonRequestWithoutCallbackUri: SIGJsonRequestWithoutCallbackUri = {
    "documentId": "string",
    "correlationId": "string",
}

const archivedAPIresendAccessLinkJsonRequest: ArchivedAPIresendAccessLinkJsonRequest = {
    "documentId": "string",
    "correlationId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    "clientGuid": "3fa85f64-5717-4562-b3fc-2c963f66afa6"
}

const sendForSignatureJsonRequest: SendForSignatureJsonRequest = {
    "documentName": "string",
    "document": "string",
    "clientId": "string",
    "clientName": "string",
    "taxYear": 0,
    "documentType": "string",
    "expiresOn": "string",
    "senderSignatureInfo": [{
        "pageNo": 0,
        "signatureControls": [{
            "type": 0,
            "top": 0,
            "left": 0,
            "required": false,
            "tooltip": "string"
        }]
    }],
    "senderSignOption": 0,
    "recipientsSignatureInfo": [{
        "emailAddress": "string",
        "signatureDataList": [{
            "pageNo": 0,
            "signatureControls": [{
                "type": 0,
                "top": 0,
                "left": 0,
                "required": false,
                "tooltip": "string"
            }]
        }]
    }],
    "isAccessCodeRequired": false,
    "callBackUri": "string",
    "correlationId": "3fa85f64-5717-4562-b3fc-2c963f66afa6"
}

const sendForSignatureWithTextIdJsonRequest: SendForSignatureWithTextIdJsonRequest = {

    "correlationId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    "documentName": "string",
    "document": "string",
    "clientId": "string",
    "clientName": "string",
    "taxYear": 0,
    "documentType": "string",
    "expiresOn": "string",
    "senderSignOption": 0,
    "callBackUri": "string",
    "isAccessCodeRequired": false,
    "recipientSignatureInfo": [{
        "emailAddress": "string",
        "controls": [{
            "textId": "string",
            "isRequired": false,
            "toolTip": "string"
        }]
    }],
    "senderSignatureInfo": [{
        "textId": "string",
        "isRequired": false,
        "toolTip": "string"
    }]

}

const setAccessJsonRequest: SetAccessJsonRequest = {
    "documentId": "string",
    "correlationId": "string",
    "userIds": [
        0
    ]
}

const signatureStatusJsonRequest: SignatureStatusJsonRequest = {
    "signingId": 0,
    "correlationId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    "documentId": [
        "string"
    ]
}

const resendAccessLinkJsonRequest: ResendAccessLinkJsonRequest = {
    "documentId": "string",
    "correlationId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    "clientGuid": "3fa85f64-5717-4562-b3fc-2c963f66afa6"
}

export const deleteRecycleBinJsonRequestCurl = generateCallbackCurlCommand(
    SIG.RECYCLE_BIN.DELETE_RECYCLE_BIN_URL,
    "DEL",
    commonSIGJsonRequest
)

export const recycleBinJsonRequestCurl = generateNoBodyCurlCommand(
    SIG.RECYCLE_BIN.RECYCLE_BIN_URL,
    "GET",
)

export const restoreRecycleBinJsonRequestCurl = generateCallbackCurlCommand(
    SIG.RECYCLE_BIN.RESTORE_RECYCLE_BIN_URL,
    "PUT",
    commonSIGJsonRequest
)

export const deleteDraftSignatureJsonRequestCurl = generateCallbackCurlCommand(
    SIG.DRAFT_REPORT.DELETE_DRAFT_SIGNATURE_URL,
    "DEL",
    commonSIGJsonRequest
)

export const getDraftSignatureJsonRequestCurl = generateNoBodyCurlCommand(
    SIG.DRAFT_REPORT.GET_DRAFT_SIGNATURES_URL,
    "GET"
)

export const archiveSignatureJsonRequestCurl = generateCallbackCurlCommand(
    SIG.DELIVERED.ARCHIVE_SIGNATURE_URL,
    "PUT",
    commonSIGJsonRequest
)

export const deleteSignatureJsonRequestCurl = generateCallbackCurlCommand(
    SIG.DELIVERED.DELETE_SIGNATURES_URL,
    "DEL",
    commonSIGJsonRequest
)

export const resendAccessLinkJsonRequestCurl = generateCurlCommand(
    SIG.DELIVERED.RESEND_ACCESS_LINK_URL,
    "POST",
    resendAccessLinkJsonRequest
)

export const sendReminderJsonRequestCurl = generateCurlCommand(
    SIG.DELIVERED.SEND_REMINDER_URL,
    "POST",
    sigJsonRequestWithoutCallbackUri
)

export const getDeliveredSignatureJsonRequestCurl = generateNoBodyCurlCommand(
    SIG.DELIVERED.GET_DELIVERED_SIGNATURES_URL,
    "GET"
)

export const getSignerDetailsJsonRequestCurl = generateNoBodyCurlCommand(
    SIG.DELIVERED.GET_SINGER_DETAIL_URL,
    "GET"
)

export const getAccessLinkJsonRequestCurl = generateNoBodyCurlCommand(
    SIG.DELIVERED.GET_ACCESS_LINK_URL,
    "GET"
)

export const getSignerDetailJsonRequestCurl = generateNoBodyCurlCommand(
    SIG.ARCHIVED.GET_SINGER_DETAIL_URL,
    "GET"
)

export const archiveAPIdeleteSignatureJsonRequestCurl = generateCallbackCurlCommand(
    SIG.ARCHIVED.DELETE_SIGNATURE_URL,
    "DEL",
    commonSIGJsonRequest
)

export const archiveAPIresendAccessLinkJsonRequestCurl = generateCurlCommand(
    SIG.ARCHIVED.RESEND_ACCESS_LINK_URL,
    "POST",
    archivedAPIresendAccessLinkJsonRequest
)

export const archiveAPIrestoreSignatureJsonRequestCurl = generateCallbackCurlCommand(
    SIG.ARCHIVED.RESTORE_SIGNATURE_URL,
    "PUT",
    commonSIGJsonRequest
)

export const archivedAPIsendReminderJsonRequestCurl = generateCurlCommand(
    SIG.ARCHIVED.SEND_REMINDER_URL,
    "POST",
    sigJsonRequestWithoutCallbackUri
)

export const SIG_Archived_GetAccessLinkRequestCurl = generateNoBodyCurlCommand(
    SIG.ARCHIVED.GET_ACCESS_LINK_URL,
    "GET"
)

export const getArchivedSignatureJsonRequestCurl = generateNoBodyCurlCommand(
    SIG.ARCHIVED.GET_ARCHIVED_SIGNATURES_URL,
    "GET"
)

export const sendForSignatureRequestCurl = generateCallbackCurlCommand(
    SIG.UPLOAD.SEND_FOR_SIGNATURE_URL,
    "POST",
    sendForSignatureJsonRequest
)

export const sendForSignatureWithTextIdRequestCurl = generateCallbackCurlCommand(
    SIG.UPLOAD.SEND_FOR_SIGNATURE_WITH_TEXTid_URL,
    "POST",
    sendForSignatureWithTextIdJsonRequest
)

export const setAccessRequestCurl = generateCurlCommand(
    SIG.UPLOAD.SET_ACCESS_URL,
    "PUT",
    setAccessJsonRequest
)

export const getSignatureStatusRequestCurl = generateNoBodyCurlCommand(
    SIG.UPLOAD.GET_SIGNATURE_STATUS_URL,
    "GET"
)

export const signatureStatusJsonRequestCurl = generateCurlCommand(
    SIG.STATUS.SIGNATURE_STATUS_URL,
    "PUT",
    signatureStatusJsonRequest
)